export const POSTAL_CODE_REGEX = /^(?:\d{4,5}|\d{3}\s\d{2})$/;

export const normalizePostalCode = (
  value: string | number | null | undefined,
): string => String(value ?? '').replace(/\s/g, '');
